<template>
  <div class="mobile">
    <div class="container">
      <div class="section1">
        <div class="select">
          <el-select
            v-model="value"
            placeholder="请选择"
            @change="onChange()"
            style="width: 120px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="section2">
        <div class="item" v-for="item in arr" :key="item.url">
          <div>
            <img alt="xxx" :src="item.img" style="width: 100%" />
          </div>
          <div class="content">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.introduction }}</div>
            <div class="botton clickStyle" @click="jump(item.url)">
              查看详情
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { csvw_url } from "../../components/config";
export default {
  name: "ListMobile",
  components: {},
  data() {
    return {
      isPhone: false,
      showCover: false,
      options: [],
      value: "",
      arr: [],
      arrAll: [],
    };
  },
  mounted: function () {
    this.fetchData();
    this.makeOptions();
  },
  methods: {
    fetchData() {
      console.log(11);
      this.axios
        .get(`${csvw_url}/front/news/tcDissertation/list`)
        .then((response) => {
          this.makeData(response);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    },
    makeData(response) {
      let arr = [];
      const dataArr = response.data.data;
      for (let item of dataArr) {
        const obj = {};
        obj.title = item.title;
        obj.introduction = item.introduction;
        obj.img = `${csvw_url}${item.picturePath}`;
        obj.attachmentPath = `${csvw_url}${item.attachmentPath}`;
        obj.url = `${item.url}`;
        obj.releaseTime = item.releaseTime;
        arr.push(obj);
      }
      this.arrAll = arr;
      this.onChange();
    },
    onChange() {
      let arr = [];
      if (this.value == "") {
        arr = this.arrAll;
      } else {
        for (let key in this.arrAll) {
          const item = this.arrAll[key];
          let str = moment(item.releaseTime).toString();
          if (str.indexOf(this.value) != -1) {
            arr.push(item);
          }
        }
      }
      this.arr = arr;
    },
    makeOptions() {
      const option = [];
      let start = 2020;
      let end = parseInt(moment().year().toString());
      for (let i = end; i >= start; i--) {
        const obj = {};
        obj.value = `${i}`;
        obj.label = `${i}`;
        option.push(obj);
      }
      option.unshift({
        value: "",
        label: "年",
      });
      this.options = option;
      this.value = "";
    },
    jump(url) {
      window.location.href = url;
    },
  },
};
</script>


<style scoped>
.container {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.section1 {
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 10px;
}
.select {
  position: relative;
  float: right;
}
.section2 {
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 50px;
  margin-top: 20px;
}
.section2 .item {
  margin-bottom: 30px;
}
.section2 .content {
  margin-left: 20px;
  margin-right: 20px;
}
.section2 .content .title {
  font-size: 18px;
  line-height: 25px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
}
.section2 .content .text {
  font-size: 12px;
  line-height: 20px;
  color: rgba(51, 51, 51, 1);
  margin-top: 15px;
}
.section2 .content .botton {
  position: relative;
  font-size: 12px;
  line-height: 25px;
  color: rgba(51, 51, 51, 1);
  margin-top: 15px;
  border: 1px solid rgba(0, 0, 0, 1);
  border-radius: 5px;
  left: 50%;
  width: 100px;
  margin-left: -50px;
  text-align: center;
}
</style>